/** Formatting shared by the Admin tabs. */
import { serverTime } from "../../lib/when";

const pad = (n: number) => String(n).padStart(2, "0");

/** `2026-10-20 09:15 UTC`, the same on every screen whatever the viewer's time zone. */
export function utcTime(iso: string | null | undefined): string {
  if (!iso) return "";
  const d = serverTime(iso);
  if (!d) return iso;
  return `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())} ${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())} UTC`;
}

/** US dollars with cents and thousands separators. */
export function usd(value: number): string {
  return `$${value.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function percent(fraction: number, digits = 1): string {
  return `${(fraction * 100).toFixed(digits).replace(/\.0+$/, "")}%`;
}
